import React from "react";
import CollapsibleCardList from "../../../components/CollapsibleCardList";
import { useSelector } from "react-redux";
import moment from "moment";

const Job = () => {
    const { app: { user } } = useSelector((state: any) => ({
        app: state.app
    }));

    const getProbation = (probation, dateOfJoining) => {
        if (probation && dateOfJoining) {
            const endDate = moment(dateOfJoining).add(probation?.probationPeriod, probation?.periodType);
            return `Yes ${moment(dateOfJoining).format("DD MMM YYYY")} - ${endDate.format("DD MMM YYYY")}`;
        }
        return "No";
    }


    const data = [
        {
            header: "Job profile",
            fields: [
                { label: "Employee Number", value: user?.employeeId },
                { label: "Job Title-Primary", value: user?.jobTitles?.name },
                { label: "In Probation?", value: getProbation(user?.probationPolicy, user?.dateOfJoining) },
                { label: "Worker Type", value: user?.timeType?.name },
                { label: "Band", value: "NA" },
                { label: "Date of Joining", value: moment(user?.dateOfJoining).format("DD MMM YYYY") },
                // { label: "Job Title-Secondary", value: "NA" },
                { label: "Notice Period", value: `${user?.noticePeriod?.noticePeriodDuration} ${user?.noticePeriod?.noticePeriodDurationType}` },
            ],
        },
        {
            header: "Employee Time",
            fields: [
                { label: "Shift", value: user?.shiftType?.name },
                { label: "Leave Plan", value: user?.leavePlans?.name },
                { label: "Attendance Number", value: user?.attendanceNumber?.name },
                { label: "Disable attendance Tracking", value: "Not mentioned" },
                { label: "Attendance Capture Scheme", value: user?.attandanceCaptureScheme?.name },
                { label: "Shift Weekly Off Rule", value: "Not mentioned" },
                { label: "Over Time", value: user?.overtimePolicy?.name },
                { label: "Weekly Off Policy", value: user?.weeklyOff?.name },
                { label: "Holidays", value: user?.holidayList?.name },
                { label: "Attendance Tracking Policy", value: user?.attandanceTrackingPolicy?.name },
                { label: "Shift Allowance Policy", value: "Not mentioned" },
            ]
        },
        {
            header: 'Other',
            fields: [
                { label: 'Expenses Policy', value: user?.expensePolicy?.name }
            ]
        }
    ];

    return (
        <CollapsibleCardList data={data} />
    );

}

export default Job;